exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-73f2000e] .yellow {\n  background-color: #ecb113 !important;\n  color: #ffffff !important;\n}\n[data-v-73f2000e] .darkRed {\n  background-color: #ed2124 !important;\n  color: #ffffff !important;\n}\n[data-v-73f2000e] .red {\n  background-color: #1e49e2 !important;\n  color: #ffffff !important;\n}\n[data-v-73f2000e] .blue {\n  background-color: #fd349c !important;\n  color: #ffffff !important;\n}\n[data-v-73f2000e] .green {\n  background-color: #269924 !important;\n  color: #ffffff !important;\n}", ""]);

// exports
